module.exports = __webpack_public_path__ + "static/media/add-circle-center-img.ffe246f6.jpg";